import {useContext} from 'react';
import {ROType} from '../../../../types/enums';
import {RetailOrderContext} from '../context/RetailOrderContext';
import CFIInformationPanel from "./CFIInformationPanel";
import {MaterialOrderInformationPanel} from "../index";

export default function InformationPanelSelector() {
    const {order} = useContext(RetailOrderContext);

    if (order.details?.roTypeID === ROType.Plumbing)
        return <CFIInformationPanel/>;

    return <MaterialOrderInformationPanel/>;
}
